import { type FilterConfig, type FilterCriterion } from '@analysis/domain';
import { type FilterConfigRepository } from '../../ports';

export interface SaveFilterConfigPayload {
  protocolId: string;
  userId: string;
  filters: FilterCriterion[];
  name: string;
}

export class SaveFilterConfigUseCase {
  constructor(private readonly repository: FilterConfigRepository) {}

  async execute(input: Readonly<SaveFilterConfigPayload>): Promise<FilterConfig> {
    const { protocolId, userId, filters, name } = input;

    const config: FilterConfig = {
      id: `${protocolId}-${userId}-${name}`,
      name,
      filters,
      createdAt: new Date(),
    };

    await this.repository.save(protocolId, userId, config);

    return config;
  }
}
